<template>

    <div>
        <div class="modal fade change-lang-modal" id="language_selection_pop_up" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="thm-heading">
                            <h3>{{$t('change-language', 'Change Your Language')}}</h3>
                        </div>
                        <button class="btn-close" type="button" data-bs-dismiss="modal" @click="()=>{this.searchTerm= null}">
                            <i class="fa-solid fa-xmark"></i>
                            <!-- <img src="@/assets/images/cancel.webp" alt=""> -->
                        </button>
                    </div>
                    <div class="modal-body">
                        <section class="sub-header-wrapper">

                            <div class="langauage-content">
                                <div class="search-lang-input">
                                    <input type="search" :placeholder="$t('search-key', 'Search')"  v-model="searchTerm" class="form-control"> <button class="btn link-btn">
                                        <img loading="lazy" src="@/assets/images/search-grey-icon.webp" alt="search">
                                    </button>
                                </div>
                                <div class="custom-language-list">
                                    <ul v-if="filteredLanguages && filteredLanguages?.length > 0">
                                        <li v-for="item in filteredLanguages" :key="item.lang_code"
                                            :class="{ 'active': selectedValue.lang_code == item.lang_code  }">
                                            <div class="form-check" @click="this.selectedValue = item">
                                                <label class="form-check-label">
                                                    {{ item.lang_name }}
                                                </label>
                                            </div>
                                        </li>                       
                                    </ul>
                                    <ul v-else>
                                        <li>
                                            <div class="form-check nodata">{{$t('no-data-found','No Data Found')}}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="two-btns">
                                <ul class="cmn-ul-list">
                                    <li><button class="btn thm-bor-but cancel-lang-btn" data-bs-dismiss="modal" @click="setSelectedValue">{{$t('close', 'Close')}}</button></li>
                                    <li><button class="btn thm-but" :disabled="!filteredLanguages?.length > 0"  @click="updateLanguage(languagesData, selectedValue.lang_code)" data-bs-dismiss="modal">{{$t('update', 'Update')}}</button></li>
                                </ul> 
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LanguageModal',
    data() {
        return {
            selectedValue: null,
            searchTerm: null,
        }
    },
    created(){
        this.setSelectedValue()
    },
    computed:{
        languagesData() {
            return this.$store.getters.languagesData;
        },
        filteredLanguages() {
            if(this.searchTerm) {
                const searchTermLower = this.searchTerm.toLowerCase();
                return this.languagesData.filter(item => item.lang_name.toLowerCase().includes(searchTermLower));
            }
            return this.languagesData
        },
    },
    methods:{        
        updateLanguage(languagesData, selectedValue) {
            this.$setCurrentLangData(languagesData, selectedValue,  this.$siteSettings?.data?.aws_url).then(() => {
                this.$successToast(this.$t('language-updated-successfully','Language changed Successfully.'));
                this.searchTerm = null;
                this.$helper.closeModal('select-language-btn')

            }).catch(e => {
                this.searchTerm= null
                this.$errorToast(e);
            })
        },
        setSelectedValue(){
            this.selectedValue = JSON.parse(localStorage.getItem('selectedLanguageObj')) || { lang_code: 'en', lang_name: 'English' };
            this.searchTerm = null;
        },
    },
}
</script>